/**
 * Rosie — NEMT Dispatch Platform
 * Copyright (c) 2025-2026 Commonwealth Transport LLC. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL. Unauthorized use, copying, or distribution is prohibited.
 */
import api from './api';

// Approve a trip, handling the pay-before-accept gate (Paula 2026-10-30):
// an unpaid self-booked ride answers 409 requiresPaymentAck; the dispatcher
// must explicitly accept it unpaid (logged server-side). Returns false if
// they declined, true once approved. Other errors are thrown.
export default async function approveTrip(tripId, approvedBy = 'paula') {
  try {
    await api.put(`/transports/${tripId}/approve`, { approvedBy });
    return true;
  } catch (err) {
    if (err.response?.status === 409 && err.response.data?.requiresPaymentAck) {
      if (!window.confirm(err.response.data.message)) return false;
      await api.put(`/transports/${tripId}/approve`, { approvedBy, acceptUnpaid: true });
      return true;
    }
    throw err;
  }
}
